'use client';

import { useUser } from './useUser';

const useUserFirstName = () => {
  const { name = '', givenName = '' } = useUser();

  if (givenName.length > 0) {
    return givenName;
  }

  if (name.length > 0) {
    return name.split(' ')[0];
  }

  return null;
};

export default useUserFirstName;
